function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 35",
  transform: "translate(-1100 -5760)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 24",
  cx: 40,
  cy: 40,
  r: 40,
  transform: "translate(1100 5760)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-baby-carriage",
  d: "M1133.181 5783.201a2.64 2.64 0 00-3.8-.661 16.568 16.568 0 00-6.381 12.961h18zm24.694 5.55h-3.375a4.5 4.5 0 00-4.5 4.5v4.5h-27a12.468 12.468 0 004.24 9.19 5.618 5.618 0 107.01 5.435 5.682 5.682 0 00-.309-1.772 18.2 18.2 0 009.619 0 5.486 5.486 0 00-.309 1.772 5.625 5.625 0 107.01-5.435 12.468 12.468 0 004.24-9.19v-4.5h3.375a1.128 1.128 0 001.124-1.125v-2.25a1.128 1.128 0 00-1.125-1.125zm-29.25 25.875a2.25 2.25 0 112.25-2.25 2.257 2.257 0 01-2.25 2.25zm22.5-2.25a2.25 2.25 0 11-2.25-2.25 2.257 2.257 0 012.25 2.25z",
  fill: "#f9cec8"
}));
var SvgBabyCarriage = function SvgBabyCarriage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80"
  }, props), _ref);
};
export default SvgBabyCarriage;